"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoGrid = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
function PromoGrid(_a) {
    var { className, numberOfColumns } = _a, props = __rest(_a, ["className", "numberOfColumns"]);
    const columnsClass = `sm:grid-cols-${numberOfColumns}`;
    return (react_1.default.createElement("div", Object.assign({ className: (0, classnames_1.default)('grid grid-cols-1 gap-y-6 sm:gap-y-0 sm:gap-x-4 md:gap-x-6 lg:gap-x-8 xl:gap-x-12 p-0 px-4 lg:px-4 max-w-screen-2xl mx-auto py-8', { [columnsClass]: numberOfColumns }, className) }, props)));
}
exports.PromoGrid = PromoGrid;
